export default "__VITE_ASSET__74d8aa3a__"